/**
 * Interpolates between two points based on a ratio
 * @param a - Starting point
 * @param b - Ending point
 * @param ratio - Interpolation ratio (0 = point a, 1 = point b, 0.5 = middle)
 * @returns Interpolated point
 */
export const interpolate = (a: Point, b: Point, ratio: number): Point => {
  const diffVec = b.sub(a)
  return a.addScaledVector(diffVec, ratio)
}

/**
 * Calculates beam geometry for a slab based on relative position
 * @param slabPoints - Array of 4 slab corner points
 * @param relativePosition - Position along the slab edge (0-1)
 * @returns Object with start and end points for the beam
 */
export const calculateBeamGeometry = (
  slabPoints: Point[],
  relativePosition: number,
): { start: Point; end: Point } => {
  const P0 = slabPoints[0]
  const P1 = slabPoints[1]
  const P2 = slabPoints[2]
  const P3 = slabPoints[3]

  // Edge 0-1: interpolate from point 0 to point 1
  const start = interpolate(P0, P1, relativePosition)
  // Edge 3-2: interpolate from point 3 to point 2 (inverse orientation)
  const end = interpolate(P3, P2, relativePosition)

  return { start, end }
}
